export default String.raw`
{% assign reviews = feedback.Reviews %}
{% for review in reviews -%}
    {% assign index = forloop.index -%}
    <div class="review review-js parent-js">
        <div class="review__details">
            <span class="product-rating">
                {{review.Rating}}/5
                {% for i in (1..5) -%}
                    {% if review.Rating >= i -%}
                        <img class="review-rating" src="css/img/star.svg" alt="star" width="24" height="23">
                    {% else -%}
                        <img class="review-rating" src="css/img/star-o.svg" alt="star" width="24" height="23">
                    {% endif -%}
                {% endfor -%}
            </span>
            {% if review.VerifiedPurchase -%}
            <span class="verified-purchase">
                <svg>
                    <use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{settings.iconStyle}}"></use>
                </svg>
                {{ translations.VerifiedPurchase }}
            </span>
            {% endif -%}
            <span class="review-author">
                {{ review.Author }}
            </span>
            <div class="review-date">
                {% include 'partials/common/date-format.html' -%}
                {{ review.CreatedDate | Date: 'dd\/MM\/yyyy' }}
            </div>
            <button class="pure-button report-review js-reportReview" data-review-id="{{review.Id}}" data-popup-class=".report-review-popup">
                {{translations.ReportReview}}
            </button>
        </div>
        <div class="review__content">
            <div class="review-description review-content-js">
                {{ review.Comment }}
            </div>
            <button class="pure-button toggle-more-review-js change-button-siblings-js">{{ translations.ReadMore }}
                <svg height="12" width="12" class="icon rotate-down">
                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}"></use>
                </svg>
            </button>
            <button class="pure-button toggle-more-review-js change-button-siblings-js hidden-js">{{ translations.Collapse }}
                <svg height="12" width="12" class="icon rotate-up" style="transform: rotate(180deg);">
                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}"></use>
                </svg>
            </button>
        </div>
    </div>
{% endfor -%}
{% assign reviewsDownloaded = feedback.ItemsPerPage | Times: feedback.PageNo -%}
{% assign reviewsToShow = feedback.ItemsPerPage | Minus: 2 -%}
{% assign reviewsToDownload = feedback.TotalItems | Minus: reviewsDownloaded -%}
{% if reviewsToDownload > 0 -%}
    {% if reviewsToDownload > feedback.ItemsPerPage -%}
        {% assign reviewsToDownload = feedback.ItemsPerPage -%}
    {% endif -%}
    {% assign url = page.Url -%}
    {% if url contains '?' -%}
        {% capture url -%}{{url}}&{{feedback.PageQueryGET}}={{feedback.PageNo|Plus:1}}{% endcapture -%}
    {% else -%}
        {% capture url -%}{{url}}?{{feedback.PageQueryGET}}={{feedback.PageNo|Plus:1}}{% endcapture -%}
    {% endif -%}
    <div class="download-more-reviews download-more-reviews-container-js">
        <button class="secondary-action-button download-more-reviews-js" data-url="{{url|H}}">{{ translations.ShowMoreReviews }} ({{ reviewsToDownload }})</button>
    </div>
{% endif -%}
{% include 'partials/common/report-review-popup.html' -%}
`